"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  Sidebar as ShadcnSidebar,
  SidebarContent,
  SidebarHeader,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarRail,
  useSidebar,
} from "@workspace/ui/components/sidebar";

type NavItem = { label: string; href: string };

const items: NavItem[] = [
  { label: "Links", href: "/links" },
  { label: "Blog", href: "/blog" },
  { label: "Bookshelf", href: "/bookshelf" },
];

export function PublicSidebar() {
  const pathname = usePathname() ?? "";
  const { isMobile, setOpenMobile } = useSidebar();

  // Determine active using longest matching path prefix (boundary-aware)
  const activeHref = items
    .filter((it) => pathname === it.href || pathname.startsWith(`${it.href}/`))
    .sort((a, b) => b.href.length - a.href.length)[0]?.href;

  return (
    <ShadcnSidebar className="md:hidden">
      <SidebarHeader>
        <div className="px-2 py-2 text-sm font-semibold text-muted-foreground">Menu</div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarMenu>
            {items.map((item) => {
              const isExact = pathname === item.href;
              const isDescendant = pathname.startsWith(`${item.href}/`);
              const isActive = isExact || (activeHref === item.href && isDescendant);
              return (
                <SidebarMenuItem key={item.href}>
                  <SidebarMenuButton asChild isActive={isActive}>
                    <Link
                      href={item.href}
                      onClick={() => {
                        if (isMobile) setOpenMobile(false);
                      }}
                    >
                      {item.label}
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              );
            })}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
      <SidebarRail />
    </ShadcnSidebar>
  );
}

